import { ActionIcon, Button, Group } from '@mantine/core'
import React from 'react'
import { TrashOff } from 'tabler-icons-react'

const BoardMenuDelete = ({selectMode,selected,isDeletePhotosLoading,setDisableFullScreen,delete_photos,board}) => {
    const onDeletePhotos = () => {
        delete_photos({board, photos: selected}).then(() => {
            setDisableFullScreen(false);
            window.location.reload();
        })
    }


    return (
        <>
            {selectMode === "delete" ? (
                <Group size={'xl'} position={'right'}>
                    <Button size="xs" color="gray" onClick={() => setDisableFullScreen(false)}>Înapoi</Button>
                    <Button size={'xs'} disabled={selected.length === 0} loading={isDeletePhotosLoading} color={'red'} onClick={onDeletePhotos}>Șterge ({selected.length})</Button>
                </Group>
            ) : (
                <Group size={'xl'} position={'right'}>
                    <ActionIcon color={'blue'}  size="lg" variant="transparent" onClick={()=> setDisableFullScreen(false)}>
                        <TrashOff  />
                    </ActionIcon>
                </Group>
            )
            }
        </>
    )}

export default BoardMenuDelete